import { Order } from '@apis/index'
import { Config } from '@apis/types'
import { Table, TableUser } from '@components'
import TableDate from '@components/table/date'
import { Fragment, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'

const BookBorrow = () => {
  const { id } = useParams()
  const {
    items: bookList,
    totalPages,
    loading,
  } = useSelector((state: any) => state.userBookBorrow)
  const [params, setParams] = useState<any>({
    page: 1,
    limit: 10,
    userId: id,
    type: 'Borrow',
  })
  const fetchBookLent = async (
    action: Config['store']['action'],
    params: any,
  ) => {
    await Order.getAllBookBorrow(action, params).catch(() => {})
  }
  useEffect(() => {
    if (!bookList?.length) {
      fetchBookLent('set', params)
    }
  }, [])

  const returnColumns = [
    {
      title: 'Book Name',
      key: 'returnName',
      render: (order: any) => (
        <TableUser
          bookCover
          avatar={order?.bookData?.coverImage}
          label={order?.bookData?.name}
          secondaryLabel={order?.bookData?.author}
        />
      ),
    },
    {
      title: 'Lender',
      key: 'returnLender',
      render: (order: any) => (
        <TableUser
          label={
            order?.bookData?.userCreated?.name ??
            order?.bookData?.adminCreated?.name
          }
          secondaryLabel={order?.bookData?.userCreated?.phoneNo ?? null}
        />
      ),
    },
    {
      title: 'Borrower',
      key: 'returnBorrower',
      render: (order: any) => (
        <TableUser
          label={order?.userCreated?.name}
          secondaryLabel={order?.userCreated?.phoneNo}
        />
      ),
    },
    {
      title: 'Lend Date',
      key: 'returnLendDate',
      render: (order: any) => (
        <TableDate date={order?.issueDate} hasTime={false} />
      ),
    },
    {
      title: 'Returned Date',
      key: 'returnReturnDate',
      render: (order: any) => (
        <TableDate date={order?.returnDate} hasTime={false} />
      ),
    },

    {
      title: 'Pickup Driver',
      key: 'returnPickupDriver',
      render: (order: any) => (
        <TableUser
          label={order?.pickUpDriver?.name}
          secondaryLabel={order?.pickUpDriver?.phoneNo}
        />
      ),
    },
    {
      title: 'Return Driver',
      key: 'returnReturnDriver',
      render: (order: any) => (
        <TableUser
          label={order?.returnDriver?.name}
          secondaryLabel={order?.returnDriver?.phoneNo}
        />
      ),
    },
  ]
  return (
    <Fragment>
      <Table
        columns={returnColumns}
        data={bookList}
        loading={loading}
        paginationProps={{
          totalPages: totalPages,
          perPage: params.limit,
          activePage: params?.page,
          handleOnClick: (pageNo) => {
            const updateParams = { ...params, page: pageNo }
            setParams(updateParams)
            fetchBookLent('set', updateParams)
          },
        }}
      />
    </Fragment>
  )
}

export default BookBorrow
